module.exports = __webpack_public_path__ + "images/icons_v2/retailer-p-4-p-program-fe2d08a1.svg";